"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SongwriterAccountCard_1 = __importDefault(require("@Components/Cards/AccountCard/SongwriterAccountCards/SongwriterAccountCard"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const SongwriterAccountCards = (props) => {
    const { allSongwriters } = props;
    return (react_1.default.createElement("section", { className: "songwriter-cards" }, allSongwriters === null || allSongwriters === void 0 ? void 0 : allSongwriters.content.map((item) => (react_1.default.createElement(SongwriterAccountCard_1.default, { key: item.id, songwriterData: item })))));
};
exports.default = (0, mobx_react_1.observer)(SongwriterAccountCards);
